import { FormattedMessage, useIntl } from 'react-intl'

import { Option } from '@models/option'
import { PatientVisitTypeEnum } from '@models/patientVisit'

import { SelectField, SelectFieldProps } from '@components/Form/Select'

type PatientVisitTypeSelectFieldProps<IsMulti extends boolean = false> = Omit<SelectFieldProps<IsMulti>, 'options'>

const options = Object.values(PatientVisitTypeEnum).map((visitType) => {
  return new Option({
    label: `enum.patient_visit_type.${visitType.toLowerCase()}`,
    value: visitType,
  })
})

const PatientVisitTypeSelectField = <IsMulti extends boolean = false>(
  props: PatientVisitTypeSelectFieldProps<IsMulti>
) => {
  const intl = useIntl()

  return (
    <SelectField
      {...props}
      options={options}
      formatOptionLabel={(o) => <FormattedMessage id={o.label} />}
      noOptionsMessage={() => {
        return intl.formatMessage({ id: 'select.no_option' })
      }}
    />
  )
}

export default PatientVisitTypeSelectField
